import React from 'react';
import ReactDOM from 'react-dom';
import MunicipalNoticeBoard from './MunicipalNoticeBoard';
import { MemoryRouter, HashRouter as Router } from 'react-router-dom';
import { skleraSDK } from '@sklera/sdk';

import './index.scss';

skleraSDK.loaded((screenData: any, appConfig: any) => {
    ReactDOM.render(
        <Router>
            <MunicipalNoticeBoard loadedAppConfig={appConfig} isPublicApp={!!screenData?.isPublicApp} />
        </Router>,
        document.getElementById('root')
    );
});
